const types = [
    {label: "group", labelCHI: "群組", value: "group"},
    {label: "page", labelCHI: "專頁", value: "page"}
]

export function getAllTypes() {
    let arr = []
    if (localStorage.getItem("i18n-lang") === 'en') {
        types.map(e => {
            arr.push({label: e.label, value: e.value})
        })
    } else {
        types.map(e => {
            arr.push({label: e.labelCHI, value: e.value})
        })
    }

    return arr
}
